// API stores VSC term as `${years} years/${miles_thousands}k`
// (see leaseend-api/utils/financialInfo.ts:parseVscTerm).
const VSC_TERM_RE = /^([0-9]*\.?[0-9]+)\s*years?\/\s*([0-9]*\.?[0-9]+)k$/i;

export const parseVscTermString = (
  term: string | null | undefined,
): { months: number; miles: number } | null => {
  if (!term) {
    return null;
  }
  const m = term.trim().match(VSC_TERM_RE);
  if (!m) {
    return null;
  }
  const years = parseFloat(m[1]);
  const milesThousands = parseFloat(m[2]);
  if (!Number.isFinite(years) || !Number.isFinite(milesThousands)) {
    return null;
  }
  return { months: Math.round(years * 12), miles: Math.round(milesThousands * 1000) };
};
